import { useEffect } from 'react';

/**
 * Hook to add hover glow effects to all control bar buttons
 * This ensures Microphone and Camera buttons get the same hover effect
 */
export const useControlBarHover = (isConnected) => {
  useEffect(() => {
    if (!isConnected) return;

    const addHoverEffects = () => {
      const controlBar = document.querySelector('.lk-control-bar');
      if (!controlBar) return;

      const buttons = controlBar.querySelectorAll('button:not(.conference-button)');
      
      buttons.forEach(button => {
        // Remove any existing hover listeners to avoid duplicates
        button.removeEventListener('mouseenter', handleMouseEnter);
        button.removeEventListener('mouseleave', handleMouseLeave);
        button.removeEventListener('mousedown', handleMouseDown);
        button.removeEventListener('mouseup', handleMouseUp);
        
        // Add hover effects
        button.addEventListener('mouseenter', handleMouseEnter);
        button.addEventListener('mouseleave', handleMouseLeave);
        button.addEventListener('mousedown', handleMouseDown);
        button.addEventListener('mouseup', handleMouseUp);
      });
    };

    const handleMouseEnter = (e) => {
      const button = e.currentTarget;
      button.style.transform = 'translateY(-2px) scale(1.05)';
      button.style.boxShadow = 
        '0 8px 24px rgba(0, 0, 0, 0.5), ' +
        '0 0 20px rgba(255, 255, 255, 0.1), ' +
        '0 0 0 1px rgba(255, 255, 255, 0.15) inset';
      button.style.zIndex = '10';
    };

    const handleMouseLeave = (e) => {
      const button = e.currentTarget;
      button.style.transform = '';
      button.style.boxShadow = '';
      button.style.zIndex = '';
    };

    const handleMouseDown = (e) => {
      const button = e.currentTarget;
      button.style.transform = 'translateY(0) scale(0.98)';
      button.style.boxShadow = 
        '0 2px 8px rgba(0, 0, 0, 0.4), ' +
        '0 0 0 1px rgba(255, 255, 255, 0.1) inset';
    };

    const handleMouseUp = (e) => {
      const button = e.currentTarget;
      // Return to hover state if still hovering
      if (button.matches(':hover')) {
        handleMouseEnter(e);
      } else {
        handleMouseLeave(e);
      }
    };

    // Run immediately
    addHoverEffects();

    // Watch for new buttons
    const controlBar = document.querySelector('.lk-control-bar');
    if (controlBar) {
      const observer = new MutationObserver(() => {
        addHoverEffects();
      });

      observer.observe(controlBar, {
        childList: true,
        subtree: true
      });

      // Also run with delays
      const timer1 = setTimeout(addHoverEffects, 300);
      const timer2 = setTimeout(addHoverEffects, 1000);

      return () => {
        observer.disconnect();
        clearTimeout(timer1);
        clearTimeout(timer2);
        
        // Clean up event listeners
        const buttons = controlBar.querySelectorAll('button:not(.conference-button)');
        buttons.forEach(button => {
          button.removeEventListener('mouseenter', handleMouseEnter);
          button.removeEventListener('mouseleave', handleMouseLeave);
          button.removeEventListener('mousedown', handleMouseDown);
          button.removeEventListener('mouseup', handleMouseUp);
        });
      };
    }
  }, [isConnected]);
};

